// Разделитель чисел (T-247, #172) — личная настройка платформы рядом с языком/темой: источник
// истины сервер (lib/userPrefs.ts, ключ "numFmt"), живая смена доходит той же шиной, что тема
// (installPrefsBridge → sharedEventBus "platform:prefs") — продукт «Настройки» пишет PUT
// /api/prefs напрямую, Оболочка подхватывает значение без F5 (useProductMenu.ts кладёт его в
// deps createOsnovaContext, см. ModuleHost.updateCtx.test.ts #185). Чистая логика разбора значения
// — в lib/numFmt.ts (тестируется отдельно, без цепочки импортов до @kit-v5).
import { useEffect, useState } from "react";
import { getPrefSync, loadAllPrefs } from "../lib/userPrefs";
import { resolveNumFmt, NUM_FMT_PREFS_KEY } from "../lib/numFmt";
import { sharedEventBus } from "../osnovaContext";
export function useNumFmt(userId) {
    const [numFmt, setNumFmt] = useState(() => resolveNumFmt(getPrefSync(NUM_FMT_PREFS_KEY)));
    useEffect(() => {
        if (!userId)
            return;
        let cancelled = false;
        loadAllPrefs().then((prefs) => {
            if (cancelled)
                return;
            setNumFmt(resolveNumFmt(prefs[NUM_FMT_PREFS_KEY]));
        });
        return () => { cancelled = true; };
    }, [userId]);
    useEffect(() => {
        return sharedEventBus.on("platform:prefs", (data) => {
            const change = data;
            if (change?.key !== NUM_FMT_PREFS_KEY)
                return;
            setNumFmt(resolveNumFmt(change.value));
        });
    }, []);
    return numFmt;
}
